import React from 'react';
import { Types } from '@wheeebo/polaris-api';
import RotationForm from './RotationForm';
function RotateVehicleRelativeForm({ onSubmit }) {
    return (React.createElement(RotationForm, { message: "Specify the rotation relative to the current rotation of the vehicle.", onSubmit: (props) => onSubmit(Types.VehicleCommandRotateVehicleRelative, props) }));
}
export default React.memo(RotateVehicleRelativeForm);
